const getDeviceType = () => {
  const userAgent = navigator.userAgent.toLowerCase();
  if (/iphone|ipad|ipod/.test(userAgent)) {
    return 'ios';
  } else if (/android/.test(userAgent)) {
    return 'android';
  } else {
    return 'web';
  }
};
const AppDownloadComponent = () => {
  const deviceType = getDeviceType();
  console.log('deviceType', deviceType);
  // Define app store links based on device type
  const iosAppLink =
    'https://apps.apple.com/fr/app/linkfluencer-buy-post-earn/id6751041089?l=en-GB'; // Replace with actual App Store link
  const androidAppLink =
    'https://play.google.com/store/apps/details?id=com.linkfluencer.linkfluencercreatorapp'; // From commented code
  const webAppLink = 'https://linkfluencer.io/get-app'; // Fallback for web
  // ('https://play.google.com/store/apps/details?id=com.linkfluencer');
  return (
    <div className="bg-[#3C2479] p-[24px] flex justify-between rounded-xl ml-[8px] mr-[8px]">
      <div className="flex flex-col justify-between">
        <div>
          <p className="text-2xl font-normal text-white">
            Get the Linkfluencer app now
          </p>
        </div>
        <div className="flex gap-[8px] items-center mt-[8px]">
          {(deviceType === 'android' || deviceType === 'web') && (
            <a
              href={deviceType === 'android' ? androidAppLink : webAppLink}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="../assets/IphoneAppStoreBadge.svg"
                className="w-[135px] h-[40px]"
              />
            </a>
          )}
          {(deviceType === 'ios' || deviceType === 'web') && (
            <a
              href={deviceType === 'ios' ? iosAppLink : webAppLink}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="../assets/MobileAppStoreBadge.svg"
                className="w-[120px] h-[40px]"
              />
            </a>
          )}
        </div>
      </div>

      {/* <QRCodeSVG
        value={appLink}
        bgColor="#3C2479"
        fgColor="#FFFFFF"
        size={100}
      /> */}
    </div>
  );
};

export default AppDownloadComponent;
